import type { ColorFormat, SelectedColor } from "store/features/colorPicker/types";
import { useColorInput } from "./useColorInput";

export interface ColorInputProps {
    color: SelectedColor;
    colorFormat: ColorFormat;
    setShowInput: (value: boolean) => void;
    setColorError: (value: string) => void;
}

export const ColorInput = ({ color, colorFormat, setShowInput, setColorError }: ColorInputProps) => {
    const { inputRef, onBlur, value, onChange } = useColorInput({ color, colorFormat, setShowInput, setColorError });
    return (
        <input
            className="w-full h-auto px-4 border-none tracking-wider outline-none"
            value={value}
            onChange={e => onChange(e.target.value)}
            ref={inputRef}
            onBlur={onBlur}
        />
    );
};
